import React from 'react'

export type AgTechHeaderMetricProps = {
    metric: string,
    value: string | number,
    settings?: AgTechHeaderMetricConfig
}

export type AgTechHeaderMetricConfig = {
    classes?: string,
    width?: number,
    margin?: string,
    metricClasses?: string,
    valueClasses?: string
}

let AgTechHeaderMetric = (props: AgTechHeaderMetricProps) => {
    let margin = props.settings?.margin ?? 'mb-[6px]';

    return (
        <div className={`row-based-vertically-centered flex-shrink div ${props.settings?.classes ?? ''}`} style={{
            width: props.settings?.width
        }}>
            <h1 className={`font-semibold text-nowrap text-more ${props.settings?.valueClasses ?? ''} ${margin}`}>{props.value?.toString() ?? 'N/A'}</h1>
            <h1 className={`font-semibold text-detail font-ellipses text-xs ${props.settings?.metricClasses ?? ''}`}>{props.metric}</h1>
        </div>
    );
};

export default AgTechHeaderMetric;